import type { Variant } from '../gameTypes.js';
import type { PianoChart } from '../pianoChart.js';
import { PALETTE_VOID } from '../builtinPulseMaps/palettes.js';
import { buildBuiltinAudio } from '../builtinPulseMaps/audioFromOnsets.js';
import audioOnsets from '../circlesBuiltinMaps/audio/invincible.onsets.json' with { type: 'json' };
import { pianoVariantsFromSpec } from './pianoFromOnsets.js';

/**
 * Invincible — DEAF KEV (NCS). The OG NCS dance banger. 174 BPM
 * hands-up DnB classic at half-time, top-tier difficulty for the
 * piano lane. Saved for players who've cleared the rest.
 *
 * Synthesised from the Circles onset analysis. See the header doc
 * on {@link import('./01-on-and-on.js').ON_AND_ON_PIANO_VARIANTS}
 * for the curated-MIDI upgrade path.
 */
export const INVINCIBLE_PIANO_VARIANTS: Record<Variant, PianoChart> = pianoVariantsFromSpec({
  baseSlug: 'invincible',
  baseTitle: 'Invincible',
  description:
    "DEAF KEV's 174 BPM hands-up DnB classic. The OG NCS dance banger, top-tier piano-lane challenge.",
  difficulty: 5,
  totalBeats: 104,
  palette: PALETTE_VOID,
  audio: buildBuiltinAudio({
    src: '/audio/circles/invincible.mp3',
    attribution: '"Invincible" by DEAF KEV [NCS Release] - https://ncs.io/invincible',
    data: audioOnsets,
  }),
  onsets: audioOnsets,
  sections: [
    {
      startBeat: 0,
      endBeat: 104,
      selectOpts: { kinds: ['lead', 'snare'], minIntensity: 0.07, minSpacing: 0.5 },
    },
  ],
});
